<template>
  <div class="accordion">
    <div class="accordion-item">
      <div
        class="accordion-header"
        :class="{ 'open-border': isOpen }"
        @click="toggleAccordion"
      >
        <div class="header-content">
          <span class="device-type">{{ title }}</span>
          <button class="accordion-button">
            <svg
              class="icon"
              :class="{ 'icon-rotate': isOpen }"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="accordion-content" v-show="isOpen">
        <slot name="content">
          <!-- Default content if no slot is provided -->
          <p>No content provided.</p>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    title: {
      type: String,
      default: "Accordion Title",
    },
    value: {
      // Support two-way binding for open state
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val); // Emit the updated state
      },
    },
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen; // Toggle the state
    },
  },
};
</script>

<style scoped>
.accordion {
  border-radius: 4px;
  margin: 30px 0;
}

.accordion-header {
  background-color: #082c3c;
  padding: 15px;
  cursor: pointer;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.open-border {
  border-top: 2px solid #146e97 !important;
  border-left: 2px solid #146e97 !important;
  border-right: 2px solid #146e97 !important;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.device-type {
  color: #ffffff;
  margin-right: 10px;
  font-weight: 600;
  font-size: 20px;
}

.accordion-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  width: 30px;
}

.accordion-button::after {
  display: none;
}
.icon {
  width: 24px;
  height: 24px;
  fill: white;
  transition: transform 0.3s ease;
}

.icon-rotate {
  transform: rotate(180deg);
}

.accordion-content {
  padding: 10px;
  background-color: #082c3c;
  border: 2px solid #146e97;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

@media (max-width: 768px) {
  .device-type {
    font-weight: 600;
    line-height: 20px;
    font-size: 16px;
    font-family: "DM Sans";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/existingUser/Accordion.vue